import { createFileRoute } from '@tanstack/react-router';
import { CabinetTransformerGame } from '@/pages/games/CabinetTransformer';

export const Route = createFileRoute('/games/cabinet-transformer')({
  component: CabinetTransformerGame,
});
